import React from "react";
import "./Home.css";
import { TypeAnimation } from "react-type-animation";
import MovingText from "react-moving-text";
import Particless from "../Particles/Particles";
import Transition from "../Transition/Transition";

function Home() {
  return (
    <div className="home-container">
      <div className="info">
        <Transition />
        <MovingText
          type="fadeInFromBottom"
          duration="1500ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          <h1>Iman Allahverdiyev</h1>
          <h5>
            <TypeAnimation
              sequence={["𝕽𝖊𝖆𝖈𝖙 𝕯𝖊𝖛𝖊𝖑𝖔𝖕𝖊𝖗", 3000, "𝕱𝖗𝖔𝖓𝖙𝖊𝖓𝖉 𝕯𝖊𝖛𝖊𝖑𝖔𝖕𝖊𝖗", 3000]}
              cursor={true}
              repeat={Infinity}
              style={{ fontSize: "2em", display: "inline-block" }}
            />
          </h5>

          <h4>
            Welcome to my portfolio, where I combine my passion for design and
            development to create web experiences that are both engaging and
            accessible to everyone.
          </h4>
        </MovingText>

      
      </div>

      <Particless />
    </div>
  );
}

export default Home;
